import { render } from "./HomeLastCoursesComponent.vue?vue&type=template&id=0b1b2f05&scoped=true"
import script from "./HomeLastCoursesComponent.vue?vue&type=script&lang=js"
export * from "./HomeLastCoursesComponent.vue?vue&type=script&lang=js"

import "./HomeLastCoursesComponent.vue?vue&type=style&index=0&id=0b1b2f05&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b1b2f05"]])

export default __exports__